import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageTransition from '../../components/PageTransition';

const Wrapper = () => {
  return (
    <>
      <Header />
      <PageTransition />
      <Footer />
    </>
  );
};

export default Wrapper;
